/* eslint-disable max-len */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/no-danger */
/* eslint-disable prefer-template */
import React, { useEffect, useRef, useState } from 'react';
import './styles.css';
import { Button, IconButton, Popover } from '@material-ui/core';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import { getWebinarDetals } from '../../../libs/apis/webinarApi';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as webinarActions from '../../../store/actions/webinarActions';
import * as roomActions from '../../../store/actions/roomActions';
import * as meActions from '../../../store/actions/meActions';

import { withRoomContext } from '../../../RoomContext';
import WelcomePageTimer from '../timerComponents/welcomePageTimer';
import io from 'socket.io-client';
import PopData from './popData';
import GradientButton from '../../customMui/newButton/newButton';
import { store } from '../../../store/store';
import { deviceAndLocation } from '../../../libs/apis/webinarAnalyticsAPI';
import deviceInfo from '../../../deviceInfo';
import Loading from '../../../components/Loader/Loading';
import CircularProgress from '@material-ui/core/CircularProgress';
import WaitingRoomAndEndMeetPage from '../../waitingRoomAndEndMeetPage/waitingRoomAndEndMeetPage';
import LinkExpirePage from '../invalidLinkPage';

function Welcomepage(props)
{

	const {
		webinarData,
		setWebinarData,
		// roomClient,
		setWebinarSocket,
		setWebinarStreamOn,
		setMe,
		setMeDislayName,
		webinarSocket, room
	} = props;

	// console.log('webbb', webinarData);
	const device = deviceInfo();

	let webinarSocketConn;

	const videoRef = useRef(null);
	// const dispatch = useDispatch();
	const navigate = useHistory();

	const [ anchorEl, setAnchorEl ] = useState(null);
	// const [ hostAnchorEl, setHostAnchorEl ] = useState(null);
	// const [ isPlaying, setIsPlaying ] = useState(false);
	const [ remainingTime, setRemainingTime ] = useState({});
	// const [ skipVideo, setSkipVideo ] = useState(true);
	const [ popData, setPopData ] = useState({});
	const [ userExist, setUserExist ] = useState(false);
	const blockRef = useRef(null);
	const [ isLoading, setIsloading ] = useState(true);
	const [ meetingStarted, setmeetingStarted ] = useState(false);

	const urlParser = new URL(window.location);

	const parameters = urlParser.searchParams;

	const webinarId = parameters.get('id');
	const uid = parameters.get('uid');
	const displayName = parameters.get('name');
	const sessionId = parameters.get('sessionId');

	const handleClick = (event, each) =>
	{
		setAnchorEl(event.currentTarget);
		setPopData(each);

	};

	// const handleHostDetails = (e) =>
	// {
	//  setHostAnchorEl(e.currentTarget);
	// };

	const handleClose = () =>
	{
		setAnchorEl(null);
		// setHostAnchorEl(null);
	};

	const getWebinar = async () =>
	{
		setIsloading(true);

		try
		{
			await getWebinarDetals(webinarId).then((res) =>
			{
				console.log('res====', res);
				if (res?.data.length>0)
				{
					setWebinarData(res?.data[0]);
				}
				else
				{
					setWebinarData([]);
				}
				setIsloading(false);
			})
				.catch(() =>
				{
					setIsloading(false);
				});

		}
		catch (e)
		{
			setIsloading(false);
			console.log('err', e);
		}
	};

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	// const openHostBio = Boolean(hostAnchorEl);
	// const hostBioId = openHostBio ? 'simple-popover' : undefined;

	useEffect(() =>
	{
		getWebinar();
		if (webinarSocket)
		{
			webinarSocket?.disconnect();
		}

	}, []);

	// const handlePlay = (e) =>
	// {
	// 	e.stopPropagation();
	// videoRef.current.play();
	// setIsPlaying(true);
	// };

	// const handlePause = (e) =>
	// {
	// 	e.stopPropagation();
	// videoRef.current.pause();
	// setIsPlaying(false);
	// };

	const handleDeviceAndLocation = async (webiData) =>
	{
		try
		{

			const response = await fetch(import.meta.env.VITE_LOCATION_CLOUDFRONT_URL, {
				headers : {
					'Origin' : 'https://apps.invc.vc'
				}
			});
			const data = await response.json();

			const CountryName = data?.country ? data?.country : '';

			const body = {
				licenseTo    : webiData?.licenseDetails?.licenseObj?.licenseTo,
				meetingId    : webiData?._id,
				sessionId    : webiData?.sessionId,
				scheduledBy  : webiData?.scheduledBy,
				startTimeUTC : webiData?.startTimeUTC,
				endTimeUTC   : webiData?.endTimeUTC,
				deviceInfo   : device?.platform,
				location     : CountryName,
				scheduleType : webiData?.scheduleType
			};

			deviceAndLocation(body).then((res) =>
			{
				if (res.status === true)
				{
					console.log('success');
				}
			})
				.catch((err) =>
				{
					console.log('error', err);
				});

		}
		catch (error)
		{
			console.error('Error getting country:', error);
		}
	};

	const handleNavigate = async () =>
	{
		try
		{
			setIsloading(true);
			if (!blockRef.current)
			{
				blockRef.current = true;
				if (localStorage.getItem('meetingId') !== parameters.get('id'))
				{
					localStorage.removeItem('meetingId');
					localStorage.removeItem('sessionId');
					localStorage.removeItem('broadcastUserId');
					localStorage.removeItem('broadcastEmailId');
					sessionStorage.removeItem('uid');
					localStorage.removeItem('broadcastUserName');
				}
				if (localStorage.getItem('meetingId') === null)
				{

					localStorage.setItem('meetingId', parameters.get('id'));
					localStorage.setItem('sessionId', parameters.get('sessionId'));
					localStorage.setItem('broadcastUserId', parameters.get('uid'));
					localStorage.setItem('broadcastEmailId', parameters.get('uid'));
					sessionStorage.setItem('uid', parameters.get('uid'));
					localStorage.setItem('broadcastUserName', parameters.get('name'));
				}

				const userId = uid;
				const userName = displayName;

				// const userId = !(uid !== null || uid !== undefined) ? uid : localStorage.getItem('broadcastUserId');
				// const userName = !(displayName !== null || displayName !== undefined) ? uid : localStorage.getItem('broadcastUserName');

				// webinarSocket = await io.connect(`https://invcwebinarsocket.instavc.com/?peerId=${userId}&roomId=${webinarData.sessionId}&displayName=${userName}`);

				// webinarSocket = await io.connect(`http://localhost:7008/?peerId=${userId}&roomId=${webinarData.sessionId}&displayName=${userName}&role=webinarUser`);

				// webinarSocket && webinarSocket.on('notification', async (notification) =>
				// {
				//  console.log(
				//      'socket "notification" event [method:"%s", data:"%o"]',
				//      notification.method, notification.data);

				//  try
				//  {
				//      switch (notification.method)
				//      {
				//          case 'UserExist':
				//          {
				//              const { data } = notification.data;

				//              setUserExist('You are already part of the webinar');
				//              break;
				//          }

				//          case 'join':
				//          {
				//              console.log('dafatas', notification.data);

				//              setWebinarSocket(webinarSocket);
				//              if (notification.data.stream)
				//              {
				//                  setWebinarStreamOn();
				//              }
				//              setMe({ peerId: userId, loginEnabled: false });
				//              setMeDislayName(userName);
				//              navigate.push(`/join-webinar?id=${parameters.get('id')}&sessionId=${parameters.get('sessionId')}&uid=${userId}&name=${displayName}`);
				//              break;
				//          }
				//          default:
				//          {
				//              console.log(
				//                  'unknown notification.method "%s"', notification.method);
				//          }
				//      }
				//  }
				//  catch (error)
				//  {
				//      console.log('error on socket "notification" event [error:"%o"]', error);
				//      // store.dispatch(requestActions.notify(
				//      //  {
				//      //      type : 'error',
				//      //      text : intl.formatMessage({
				//      //          id             : 'socket.requestError',
				//      //          defaultMessage : 'Error on server request'
				//      //      })
				//      //  }));
				//  }
				// });

				const socketURI = import.meta.env.VITE_WEBINAR_SOCKET;

				webinarSocketConn = await io.connect(`${socketURI}`);

				webinarSocketConn.on('connect', () =>
				{
					webinarSocketConn.emit('room', store.getState().me.id, sessionId, userId, userName, 'webinarUser', webinarId, store.getState().settings.countryName, store.getState().settings.countryCode, function(data)
					{
						console.log('userId', userId);
						if (data.method === 'UserExist')
						{
							setUserExist('You are already part of the webinar.');
							webinarSocketConn.disconnect();
						}
						else if (data.method === 'SessionExpire')
						{
							store.dispatch(roomActions.setSessionExp(true));
							webinarSocketConn.disconnect();
						}
						else if (data.method === 'NotFound')
						{
							// setUserExist('The host turned down your request to join the webinar.');
							setUserExist('The host rejected your request to join the webinar.');
							webinarSocketConn.disconnect();
						}
						else
						{

							setWebinarSocket(webinarSocketConn);
							if (data.stream)
							{
								setWebinarStreamOn();
							}
							setMe({ peerId: store.getState().me.id, loginEnabled: false, email: window.atob(userId), name: userName, socketId: data.webinarUser.socketId });
							setMeDislayName(userName);
							navigate.push(`/join-webinar?id=${parameters.get('id')}&sessionId=${parameters.get('sessionId')}&uid=${userId}&name=${displayName}`);
						}

						blockRef.current = false;
						setIsloading(false);
					});
				});

				webinarSocketConn.on('disconnect', (reason) =>
				{
					blockRef.current = false;
					setIsloading(false);
					// console.log("Socket disconnected. Reason:", reason);
				});

				webinarSocketConn.on('connect_error', (error) =>
				{
					blockRef.current = false;
					setIsloading(false);
					webinarSocketConn.disconnect();
				});

				// webinarSocketConn.emit('room', store.getState().me.id, sessionId, userId, userName, 'webinarUser', webinarId, store.getState().settings.countryName, store.getState().settings.countryCode, function(data)
				// {
				// 	console.log('userId', userId);
				// 	if (data.method === 'UserExist')
				// 	{
				// 		setUserExist('You are already part of the webinar.');
				// 		webinarSocketConn.disconnect();
				// 	}
				// 	else if (data.method === 'SessionExpire')
				// 	{
				// 		store.dispatch(roomActions.setSessionExp(true));
				// 		webinarSocketConn.disconnect();
				// 	}
				// 	else if (data.method === 'NotFound')
				// 	{
				// 		// setUserExist('The host turned down your request to join the webinar.');
				// 		setUserExist('The host rejected your request to join the webinar.');
				// 		webinarSocketConn.disconnect();
				// 	}
				// 	else
				// 	{

				// 		setWebinarSocket(webinarSocketConn);
				// 		if (data.stream)
				// 		{
				// 			setWebinarStreamOn();
				// 		}
				// 		setMe({ peerId: store.getState().me.id, loginEnabled: false, email: window.atob(userId), name: userName, socketId: data.webinarUser.socketId });
				// 		setMeDislayName(userName);
				// 		navigate.push(`/join-webinar?id=${parameters.get('id')}&sessionId=${parameters.get('sessionId')}&uid=${userId}&name=${displayName}`);
				// 	}

				// 	blockRef.current = false;
				// });

				handleDeviceAndLocation(webinarData);
			}
		}
		catch (err)
		{
			setIsloading(false);
		}
		finally
		{
			// setIsloading(false);
		}

	};

	// useEffect(() =>
	// {
	// 	const calculateTimeLeft = () =>
	// 	{
	// 		const now = new Date();
	// 		const meetingTime = new Date(webinarData?.startTimeUTC);
	// 		const diff = meetingTime - now;

	// 		if (diff > 0)
	// 		{
	// 			const days = Math.floor(diff / (1000 * 60 * 60 * 24));
	// 			const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	// 			const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
	// 			const seconds = Math.floor((diff % (1000 * 60)) / 1000);

	// 			setTimeLeft({ days, hours, minutes, seconds });
	// 		}
	// 		else
	// 		{
	// 			setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 }); // Time is up
	// 		}
	// 	};

	// 	calculateTimeLeft(); // Initial calculation
	// 	const timer = setInterval(calculateTimeLeft, 1000); // Declare and initialize timer

	// 	return () =>
	// 	{
	// 		clearInterval(timer); // Cleanup on unmount
	// 	};
	// }, [ webinarData?.startTimeUTC ]);

	console.log('meetingStartedmeetingStarted', webinarData, meetingStarted, isLoading);

	return (
		<>
			{(room?.inLobby || room?.locked || room?.sessionExp) &&
			<WaitingRoomAndEndMeetPage />}
			{!isLoading && (webinarData && Object.keys(webinarData).length > 0 ?
				<div className='resColRow ovrAuto fullH'>
					<div className='flexCol fullH pdngLG gap16  wlCmpt'>
						<div className='flexRow gap8'>
							<span className='welBck wlCmpt ellipsisTxt pdngSM brdrRadiusSM'>{webinarData?.meetingName}</span>
							<span className='welBck wrCmpt pdngSM brdrRadiusSM'>{new Date(webinarData?.startTimeUTC).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })} - {new Date(webinarData?.startTimeUTC).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZoneName: 'short' })}</span>
						</div>
						{/* <div className='flexRow gap16'>
<img src={webinarData?.profileImage ? webinarData?.profileImage : '/themeAvatar3.svg'} alt='speaker' className='spkr' />
<div className='flexAutoCol'>
<span className='small'>Organiser</span>
<span className='sHdng capTxt ellipsisTxt'>{webinarData?.extra?.name}</span>
</div>
</div> */}
						{
							webinarData?.speakersData &&
							<div className='flexWrap gap16 pdngTSM'>
								{
									webinarData?.speakersData?.map((each) => (
										<div key={each?._id} className='flexRow gap16 speakerDiv'>
											<img src={each?.speakerImage?.publicUrl ? (each?.speakerImage?.publicUrl + '/' + each?.speakerImage?.key) : '/themeAvatar2.svg'} className={each?.speakerImage?.publicUrl ? 'speakerImg' : 'speakerImg pdngXXS'} alt='speaker' />
											<div className='flexAutoCol jCntr fullW'>
												<span className='small'>Speaker</span>
												<span className='sHdng capTxt ellipsisTxt'>{each?.speakerName}</span>
												<span className='small link underline' onClick={(e) => handleClick(e, each)}>View full Bio</span>
											</div>
										</div>
									))
								}
								<PopData id={id} open={open} anchorEl={anchorEl} handleClose={handleClose} webinarData={webinarData} popData={popData} />
							</div>
						}
						<div className='flexCol pdngVMD vTag pRel' >
							<video
								className='brdrRadiusMD welcomeAspect'
								width='100%' height='100%'
								controls

								src={webinarData?.webinarIntroVideo?.url ? `${webinarData?.webinarIntroVideo?.url}` : 'https://invc2023uploads.s3.ap-south-1.amazonaws.com/public/bannerImages/1700572545948Welcome to Webinar With Audio.mp4'}
								ref={videoRef}
								// onEnded={handlePause}
								// onClick={handlePause}
							>
								Your browser does not support the video tag.
							</video>
							{/* {
!isPlaying &&
<div className='flexAutoCol aCntr jCntr fullH fullW pAbs'>
<IconButton onClick={handlePlay}>
<div className='flexAutoCol aCntr jCntr playPause pRel'>
<PlayArrowRoundedIcon style={{ color: 'white' }} fontSize='large' />
</div>
</IconButton>
</div>
} */}
						</div>
						{
							webinarData?.meetingDescription &&
							<div className='flexCol gap8'>
								<span className='mHdng' >Description about this webinar</span>
								<span className='meetDes' >
									<div dangerouslySetInnerHTML={{ __html: webinarData?.meetingDescription }} />
								</span>
							</div>
						}
					</div>
					<div className='flexCol fullH aCntr jCntr pdngMD wrCmpt'>
						<div className='flexMinWidthCol jCntr aCntr gap16 tmrCmpt'>
							<WelcomePageTimer startTime={webinarData?.startTimeUTC} setIsStart={() => setmeetingStarted(true)}/>
							<span className='lHdng capTxt'>Hello, {displayName}</span>
							<span>{
								!meetingStarted ?
									'Stay tuned ! The Webinar is about to start' :
									'The Webinar has started click on join webinar'
							}</span>

							{!isLoading ?
								<GradientButton
									color='primary'
									variant='contained'
									disabled={!meetingStarted}
									disableElevation
									style={{ padding: '8px 42px' }}
									onClick={() => handleNavigate()}
								>JOIN WEBINAR</GradientButton>
								:
								<CircularProgress variant='indeterminate' disableShrink size='2rem' />}
							{userExist && <span className='pdngXXS nameErr'>{userExist}</span>}

						</div>
						<div className='flexAutoCol aCntr jEnd'>
							<span>If not you? <span className='link underline pdngRXXS' onClick={() => navigate.push(`/register?id=${webinarId}&sessionId=${sessionId}`)}>Click here </span> to register</span>
						</div>
					</div>
				</div>
				:<LinkExpirePage/>)}
			{
				isLoading && <Loading />
			}
		</>
	);
}

Welcomepage.propTypes =
{
	// roomClient         : PropTypes.object.isRequired,
	webinarData        : PropTypes.any,
	setWebinarData     : PropTypes.func,
	setWebinarSocket   : PropTypes.func,
	setWebinarStreamOn : PropTypes.func,
	setMe              : PropTypes.any,
	setMeDislayName    : PropTypes.any,
	webinarSocket      : PropTypes.any,
	room               : PropTypes.any
};

const mapStateToProps = (state) =>
{
	return {
		webinarData   : state.webinar.webinarData,
		room          : state.room,
		webinarSocket : state.webinar.webinarSocket
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setWebinarData : (webinarData) =>
		{
			dispatch(webinarActions.setWebinarData(webinarData));
		},
		setWebinarSocket : (socketVal) =>
		{
			dispatch(webinarActions.setWebinarSocket(socketVal));
		},
		setWebinarStreamOn : () =>
		{
			dispatch(roomActions.setWebinarStreamOn({ webinarStreamOn: true }));
		},
		setMe : ({ peerId, loginEnabled, email, name, socketId }) =>
		{
			dispatch(meActions.setMe({ peerId, loginEnabled, email, name, socketId }));
		},
		setMeDislayName : (displayName) =>
		{
			dispatch(meActions.setMeDislayName(displayName));
		}

	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.webinar.webinarData === next.webinar.webinarData &&
				prev.room === next.room
			);
		}
	}
)(Welcomepage));